
import { Component, mixins } from 'nuxt-property-decorator'
import { FSXABaseLayout } from 'fsxa-pattern-library'
import BasePicture from '../../base/BasePicture.vue'
import BaseButton from '../../base/BaseButton.vue'
import DesignLogo from '../../svgs/DesignLogo.vue'
import IImage from '../../../shared/general/interfaces/IImage'
import { mapImage } from '../../../shared/general/services/ImageService'
import LifespanAwareContentWrapper from '../wrappers/LifespanAwareContentWrapper'
import { IPayload } from '../../../shared/general/interfaces/ILandingPage'
import { resolutions } from '../../../shared/general/services/LandingPageService'
import getLinkObject from '../../../shared/fsxa/services/LinkService'
import WhiteRichText from '../../richtext/WhiteRichText.vue'
import PageContent from '../PageContent.vue'
import PageHeader from '../PageHeader.vue'
import BasePage from '../base/BasePage.vue'
import LandingPageHeader from '../../LandingPageHeader.vue'
import { trackCta } from '../../../shared/general/tracking/TrackingService'
import { ILink } from '../../../shared/general/interfaces/ILink'

@Component({
  name: 'PtLandingPage',
  components: {
    LandingPageHeader,
    PageHeader,
    PageContent,
    BaseButton,
    BasePicture,
    DesignLogo,
    LifespanAwareContentWrapper,
    WhiteRichText,
  },
})
export default class PtLandingPage extends mixins(BasePage, FSXABaseLayout<IPayload>) {
  private readonly resolutions : Record<number | 'max', string> = resolutions

  $refs! : {
    landingPageBanner ?: HTMLElement
  }

  created () {
    this.$store.commit('Page/setPageType', 'LandingPage')
  }

  private get coverImage () : IImage {
    return mapImage(this.data.pt_image, this.data.pt_image_alt_text, this.data.pt_image_title_text)
  }

  private get logo2 () : IImage {
    return mapImage(this.data.pt_logo_2, this.data.pt_logo_2_alt_text, this.data.pt_logo_2_alt_text)
  }

  private get logo3 () : IImage {
    return mapImage(this.data.pt_logo_3, this.data.pt_logo_3_alt_text, this.data.pt_logo_3_alt_text)
  }

  private get description () : string {
    return this.data.pt_text || ''
  }

  private get campaignCta () : ILink {
    return getLinkObject(this.data.pt_campaign_cta, this.getUrlByPageId)
  }

  private get primaryCta () : ILink {
    return getLinkObject(this.data.pt_primary_cta, this.getUrlByPageId)
  }

  private get secondaryCta () : ILink {
    return getLinkObject(this.data.pt_secondary_cta, this.getUrlByPageId)
  }

  private clickCta (cta ?: ILink) : void {
    if (!this.$refs.landingPageBanner) return
    trackCta(this.$refs.landingPageBanner, {
      cta_type: 'cta_lp',
      icon_name: cta?.iconName || '',
      link_text: cta?.label || '',
      link_url: cta?.url || '',
    })
  }
}
